import React from 'react';
import {useFormSubmit} from '../../../controllers/useSubmitForm';
import {Form} from '../../../components/form/Form';

export const AddPotentialCustomerForm = props => {
  let {onSubmit} = useFormSubmit({
    uri: '/PotentialCustomers',
    ...props,
  });
  return (
    <Form
      onSubmit={onSubmit}
      header={'Add Potential Customer'}
      submitAction={'Save'}
      layoutFields={[
        {
          type: 'text',
          field: 'name',
          label: 'Name',
        },
      ]}
    />
  );
};
